import React from 'react';
import _ from 'lodash';
import {Icon} from 'antd';
import { toggleSidebar, toggleMeSetting } from '../actions';
import classnames from 'classnames'
import { Link } from 'react-router';
import customization from 'customization';

import MeSetting from './MeSetting';

import './style.css';

const Sidebar = function ({
  model,
  username,
  email,
  children,
  dispatch,
  generalRecommend,
  subjects
}) {
  return (
    <div className="sidebar">
      {children}
    </div>
  );
}

export default Sidebar;



/** WEBPACK FOOTER **
 ** ./src/app/modules/sidebar/components/Component.js
 **/